// extracted by mini-css-extract-plugin
export var chevronIcon = "footer-module--chevron-icon--38300";
export var chevronOpen = "footer-module--chevron-open--2f1ed";
export var content = "footer-module--content--8e1bc";
export var copyrightContainer = "footer-module--copyright-container--9b3ce";
export var copyrightLinkText = "footer-module--copyright-link-text--338df";
export var copyrightLinkWrapper = "footer-module--copyright-link-wrapper--dda0a";
export var divider = "footer-module--divider--6b3bf";
export var footer = "footer-module--footer--fa9cf";
export var footerCta = "footer-module--footer-cta--d7ab4";
export var globeIcon = "footer-module--globe-icon--c8cbb";
export var image = "footer-module--image--f5381";
export var link = "footer-module--link--54bed";
export var linkWrapper = "footer-module--link-wrapper--55b02";
export var localeActive = "footer-module--locale-active--1beb8";
export var localeButton = "footer-module--locale-button--26d8c";
export var localeDropdown = "footer-module--locale-dropdown--a64aa";
export var localeOption = "footer-module--locale-option--d1379";
export var localeText = "footer-module--locale-text--98cd6";
export var localeWrapper = "footer-module--locale-wrapper--1d1ed";
export var logo = "footer-module--logo--841c3";
export var logoContainer = "footer-module--logo-container--21209";
export var lowerContainer = "footer-module--lower-container--a3a80";
export var mainContainer = "footer-module--main-container--57f8d";
export var navContainer = "footer-module--nav-container--42df1";
export var oneTrustSettingsLink = "footer-module--one-trust-settings-link--dd10a";
export var privacyChoices = "footer-module--privacyChoices--0d8d5";
export var selectDisable = "footer-module--select-disable--b8a2a";
export var socialMediaContainer = "footer-module--social-media-container--8924f";
export var socialMediaLink = "footer-module--social-media-link--dbe4d";
export var title = "footer-module--title--84fb3";
export var upperContainer = "footer-module--upper-container--77c16";